import i18n from '../../i18n/i18n';
import { tr } from '../../i18n/i18n';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { IClassRoomRequest } from '../../interface/classRoomModel';
import { ICreateSubjectError, ICreateSubjectResponseBody } from '../../interface/subjectModel';
import axios, { AxiosError } from 'axios';
import { IGetTeacherDetailsRequestParams } from '../../interface/teacherModel';
import {
  IClassroomAssignRequest,
  IGetAllTeachers,
  IGetByIdClassroomAssignResponse,
  IGetClassroomAssignResponse,
} from '../../interface/teacherClassroomAssignModel';
import {

  createClassroomAssignService,
  updateClassroomAssignService,
  removeAssignedClassroom,
  getAllTeachersService,
  getClassroomAssignService,
  getClassroomAssignByIdService,
  downloadAssignedTeacherReportService,
} from '../../services/assignClassroom';

export const createClassroomAssign = createAsyncThunk<
  ICreateSubjectResponseBody,
  IClassroomAssignRequest,
  { rejectValue: ICreateSubjectError }
>('assign-class/create', async (body, { rejectWithValue }) => {
  try {
    const response = await createClassroomAssignService(body);
    return response;
  } catch (err: any) {
    if (axios.isAxiosError(err)) {
      const error = err as AxiosError<ICreateSubjectError>;
      const errorResponse = error.response?.data;
      return rejectWithValue(errorResponse || { message: i18n.t('msg.unknown_error', i18n.t('toast.unknown_error', 'Unknown error')) });
    } else {
      return rejectWithValue({ message: err.message });
    }
  }
});

export const updateClassroomAssign = createAsyncThunk<
  ICreateSubjectResponseBody,
  { body: IClassRoomRequest; classId: string; teacherId: string },
  { rejectValue: ICreateSubjectError }
>('assign-class/update', async ({ body, classId, teacherId }, { rejectWithValue }) => {
  try {
    const response = await updateClassroomAssignService(classId, teacherId, body);
    return response;
  } catch (err: any) {
    if (axios.isAxiosError(err)) {
      const error = err as AxiosError<ICreateSubjectError>;
      const errorResponse = error.response?.data;
      return rejectWithValue(errorResponse || { message: i18n.t('msg.unknown_error', i18n.t('toast.unknown_error', 'Unknown error')) });
    } else {
      return rejectWithValue({ message: err.message });
    }
  }
});

export const deleteClassroomAssign = createAsyncThunk<
  ICreateSubjectResponseBody,
  string,
  { rejectValue: ICreateSubjectError }
>('assign-class/delete', async (assignId, { rejectWithValue }) => {
  try {
    const response = await removeAssignedClassroom(assignId);
    return response;
  } catch (err: any) {
    if (axios.isAxiosError(err)) {
      const error = err as AxiosError<ICreateSubjectError>;
      const errorResponse = error.response?.data;
      return rejectWithValue(errorResponse || { message: i18n.t('msg.unknown_error', i18n.t('toast.unknown_error', 'Unknown error')) });
    } else {
      return rejectWithValue({ message: err.message });
    }
  }
});

export const getAllTeachers = createAsyncThunk<
  IGetAllTeachers,
  void,
  { rejectValue: ICreateSubjectError }
>('assign-class/get-all-teachers', async (_, { rejectWithValue }) => {
  try {
    const response = await getAllTeachersService();
    return response;
  } catch (err: any) {
    if (axios.isAxiosError(err)) {
      const error = err as AxiosError<ICreateSubjectError>;
      const errorResponse = error.response?.data;
      return rejectWithValue(errorResponse || { message: i18n.t('msg.unknown_error', i18n.t('toast.unknown_error', 'Unknown error')) });
    } else {
      return rejectWithValue({ message: err.message });
    }
  }
});

export const getClassroomAssign = createAsyncThunk<
  IGetClassroomAssignResponse,
  { params: IGetTeacherDetailsRequestParams },
  { rejectValue: ICreateSubjectError }
>('assign-class/get-assign-class', async ({ params }, { rejectWithValue }) => {
  try {
    const response = await getClassroomAssignService(params);
    return response;
  } catch (err: any) {
    if (axios.isAxiosError(err)) {
      const error = err as AxiosError<ICreateSubjectError>;
      return rejectWithValue({
        status: error.response?.status || 500,
        message: error.response?.data?.message || i18n.t('toast.unknown_error', 'Unknown error'),
      });
    } else {
      return rejectWithValue({ status: err.status || 500, message: err.message });
    }
  }
});

export const getClassroomAssignById = createAsyncThunk<
  IGetByIdClassroomAssignResponse,
  { classId: string; teacherId: string },
  { rejectValue: ICreateSubjectError }
>('assign-class/get-by-id', async ({ classId, teacherId }, { rejectWithValue }) => {
  try {
    const response = await getClassroomAssignByIdService(classId, teacherId);
    return response;
  } catch (err: any) {
    if (axios.isAxiosError(err)) {
      const error = err as AxiosError<ICreateSubjectError>;
      const errorResponse = error.response?.data;
      return rejectWithValue(errorResponse || { message: i18n.t('msg.unknown_error', i18n.t('toast.unknown_error', 'Unknown error')) });
    } else {
      return rejectWithValue({ message: err.message });
    }
  }
});

export const fetchAssignedTeacherReport = createAsyncThunk<
  void,
  void,
  { rejectValue: ICreateSubjectError }
>('assign-class/report', async (_, { rejectWithValue }) => {
  try {
    await downloadAssignedTeacherReportService();
  } catch (err: any) {
    if (axios.isAxiosError(err)) {
      const error = err as AxiosError<ICreateSubjectError>;
      return rejectWithValue({
        status: error.response?.status || 500,
        message: error.response?.data?.message || i18n.t('toast.unknown_error', 'Unknown error'),
      });
    } else {
      return rejectWithValue({ status: err.status || 500, message: err.message });
    }
  }
});
